<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const handleNextStep = async () => {
  await handleNext('tutorial_terraforming_resources')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        Terraforming is controlled from the resources section,
      </p>
      <p class="pb-2">
        Let's decide which planet(s) we should terraform.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Find the Terraforming Image on the resources section, click on it. Then enable terraforming for a planet.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Done!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>